import { backendUrl } from './axios';
import w1  from '../assets/images/w1.png';
import w2  from '../assets/images/w2.png';
import s1  from '../assets/images/s1.png';
import s2  from '../assets/images/s2.png';
import n1  from '../assets/images/n1.png';
import n2  from '../assets/images/n2.png';
import sh1 from '../assets/images/sh1.png';
import sh2 from '../assets/images/sh2.png';
import l   from '../assets/images/l.png';

export const AVATAR_MAP = {
  warrior_male:    w1,
  warrior_female:  w2,
  sura_male:       s1,
  sura_female:     s2,
  ninja_male:      n1,
  ninja_female:    n2,
  shaman_male:     sh1,
  shaman_female:   sh2,
  lycan_male:      l,
};

export const AVATARS = [
  { value: 'warrior_male',   label: 'Warrior male',   image: w1 },
  { value: 'warrior_female', label: 'Warrior female', image: w2 },
  { value: 'sura_male',      label: 'Sura male',      image: s1 },
  { value: 'sura_female',    label: 'Sura female',    image: s2 },
  { value: 'ninja_male',     label: 'Ninja male',     image: n1 },
  { value: 'ninja_female',   label: 'Ninja female',   image: n2 },
  { value: 'shaman_male',    label: 'Shaman male',    image: sh1 },
  { value: 'shaman_female',  label: 'Shaman female',  image: sh2 },
  { value: 'lycan_male',     label: 'Lycan male',     image: l },
];

/**
 * Priority:
 * 1. user.image  — manually uploaded file  → backendUrl/users/filename
 * 2. user.avatar starting with http        → Discord CDN URL (use as-is)
 * 3. user.avatar key in AVATAR_MAP         → registration character avatar
 * 4. null                                  → caller decides fallback (gender icon / noImage)
 */
export const resolveAvatar = (user) => {
  if (!user) return null;
  if (user.image)                              return `${backendUrl}/users/${user.image}`;
  if (user.avatar?.startsWith('http'))         return user.avatar;
  if (user.avatar && AVATAR_MAP[user.avatar])  return AVATAR_MAP[user.avatar];
  return null;
};
